import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Avatar from '@material-ui/core/Avatar';
import { PrimaryButton, NegativeButton, LinkText, ButtonWithIcon, DotBadge, CountBadge, ApproveDenialText, } from '../../components';
export const PagingTable = (props) => {
    const { columns, rows, loading = false, loadingApproval = false, onClickRow, onClickContent = () => { }, onClickDetailButton = () => { }, onClickApproveButton = () => { }, onClickDenialButton = () => { }, onClickExpandMore = () => { }, onClickCopyCreate = () => { }, onClickPayment = () => { }, } = props;
    const { t } = useTranslation();
    const [isHoverLink, setIsHoverLink] = useState(false);
    const onClickRowEvent = (id) => {
        // リンクテキスト上で行クリックした場合は行クリックイベントは発火させない
        if (isHoverLink || typeof onClickRow === 'undefined')
            return;
        onClickRow(id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TableContainer, null,
            React.createElement(Table, { stickyHeader: true },
                React.createElement(STableHead, null,
                    React.createElement(TableRow, null, columns.map((column) => (React.createElement(TableCell, { key: column.id, align: column.align, style: { minWidth: column.minWidth } }, column.label))))),
                React.createElement(TableBody, null, rows.map((row) => {
                    return (React.createElement(STableRow, { tabIndex: -1, key: row.id, hover: typeof onClickRow !== 'undefined', onClick: () => onClickRowEvent(row.id) }, columns.map((column) => {
                        var _a;
                        const value = row[column.id];
                        // approveButtonが設定されている場合、承認・否認ボタンを表示
                        if (column.id === 'approveButton') {
                            return (React.createElement(TableCell, { key: column.id, align: column.align }, row.isApprove === null ? (React.createElement(React.Fragment, null,
                                React.createElement(PrimaryButton, { size: "small", loading: loadingApproval, onClick: () => onClickApproveButton(row.id) }, t('承認')),
                                React.createElement(SSpacer, null,
                                    React.createElement(NegativeButton, { size: "small", loading: loadingApproval, onClick: () => onClickDenialButton(row.id) }, t('否認'))))) : (React.createElement(ApproveDenialText, { isApprove: row.isApprove }))));
                            // paymentButtonが設定されている場合、支払うボタンを表示
                        }
                        else if (column.id === 'paymentButton') {
                            return (React.createElement(TableCell, { key: column.id, align: column.align }, row.isPayed ? (React.createElement("p", { style: { margin: '0 12px 0 0' } }, t('支払済'))) : row.isCashOnly ? (React.createElement("p", { style: { margin: 0 } }, t('現金支払い'))) : (React.createElement(React.Fragment, null, row.isPartTimeOneDay && (React.createElement(PrimaryButton, { size: "small", onClick: () => onClickPayment(row.id) }, t('支払う')))))));
                            // detailButtonが設定されている場合、詳細ボタンを表示
                        }
                        else if (column.id === 'detailButton') {
                            return (React.createElement(TableCell, { key: column.id, align: column.align },
                                React.createElement(PrimaryButton, { size: "small", onClick: () => onClickDetailButton(row.id) }, t('詳細'))));
                            // 業務内容列はリンクにする
                        }
                        else if (column.id === 'content') {
                            return (React.createElement(TableCell, { key: column.id, align: column.align },
                                React.createElement("div", { onMouseEnter: () => setIsHoverLink(true), onMouseLeave: () => setIsHoverLink(false) },
                                    React.createElement(DotBadge, { isShow: row.notificationFlag },
                                        React.createElement(LinkText, { onClick: () => (onClickContent !== undefined ? onClickContent(row.id) : alert()) }, value)))));
                            // ユーザー列
                        }
                        else if (column.id === 'userName') {
                            return (React.createElement(TableCell, { key: column.id, align: column.align },
                                React.createElement("div", { onMouseEnter: () => setIsHoverLink(true), onMouseLeave: () => setIsHoverLink(false) },
                                    React.createElement(CountBadge, { count: row.unreadCount },
                                        React.createElement(Avatar, { src: (_a = row.userImage) === null || _a === void 0 ? void 0 : _a.url, alt: 'プロフィール画像' })),
                                    React.createElement(LinkText, { display: 'inline-block', marginLeft: '10px', onClick: () => (onClickContent !== undefined ? onClickContent(row.id) : alert()) }, value))));
                            // copyCreateが設定されている場合、コピーして新規作成ボタンを表示
                        }
                        else if (column.id === 'copyCreate') {
                            return (React.createElement(TableCell, { key: column.id, align: column.align },
                                React.createElement(PrimaryButton, { size: "small", onClick: () => onClickCopyCreate(row.id) }, t('コピーして新規作成'))));
                            // 通常の文字表示
                        }
                        else {
                            return (React.createElement(TableCell, { key: column.id, align: column.align }, column.format && typeof value === 'number' ? column.format(value) : value));
                        }
                    })));
                })))),
        React.createElement(SExpandMoreButtonArea, null,
            React.createElement(ButtonWithIcon, { text: "\u3082\u3063\u3068\u898B\u308B", iconName: "expand_more", iconPosition: "end", loading: loading, onClick: onClickExpandMore }))));
};
const STableHead = styled(TableHead) `
  th {
    background-color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
`;
const STableRow = styled(TableRow) `
  &:hover {
    cursor: ${({ hover }) => hover && 'pointer'};
  }
`;
const SSpacer = styled.span `
  margin-left: 8px;
`;
const SExpandMoreButtonArea = styled.div `
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
`;
